import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import _ from 'lodash';

const GeneralSelect = ({
	label,
	name,
	value,
	onChange,
	onBlur,
	invalid,
	error,
	onSelect,
	handleLabelOptions,
	disabled,
	requestApi,
	itemsSelect,
	params,
	isMulti
}) => {
	const [isLoading, setIsLoading] = useState(true);
	const [isDisabled, setIsDisabled] = useState(true);
	const [paramsSelect, setParamsSelect] = useState(null);

	const [listItemsSelect, setListItemsSelect] = useState([]);

	const getItems = async () => {
		// console.log(`get Items:  ${label}?`);
		setIsLoading(true);
		let response = null;

		try {
			response = await requestApi(params);
			let itemsSelect = [];
			
			response.map(item => {
				itemsSelect.push({
					item: item,
					value: item._id,
					label: (handleLabelOptions === undefined ?  item.name : handleLabelOptions(item)),
				})
			})
			setListItemsSelect(itemsSelect);
			setIsLoading(false);
		} catch (err) {
			switch (err.status) {
				default:
					console.log(err.message);
			}
			setIsLoading(false);
		}
	};

	const [selectedVisibility, setselectedVisibility] = useState('');

	function getValueFromListSelector(value) {
		return listItemsSelect.find(item => item.item._id === value._id);
	}

	function handleSelectVisibility(optionSelected) {
		setselectedVisibility(optionSelected);
		onSelect(optionSelected);
		invalid = false;
		error = null;
	}

	useEffect(() => {
		// console.log('remontaje de selector??')
		if(requestApi != null){
			getItems();
		}else{
			setListItemsSelect(itemsSelect);
			setIsLoading(false);
		}
		setIsDisabled(disabled);
	}, []);

	useEffect(() => {
		if(!_.isEqual(params, paramsSelect)){
			setParamsSelect(params);
			if(params != null){
				getItems();
				handleSelectVisibility('');
			}
			
		}
	}, [params])

	useEffect(() => {
		if(disabled){
			handleSelectVisibility('');
			setIsDisabled(false);
		}
	}, [disabled])

	useEffect(() => {
		if (value) {
			const itemListSelected = getValueFromListSelector(value);
			handleSelectVisibility(itemListSelected);
		}
	}, [listItemsSelect]);

	const selectStyle = {
		border: invalid ? '1px solid red' : '1px solid #ccc',
	};

	const selectClassName = invalid ? 'select-is-invalid' : '';

	return (
		<div>
			<label htmlFor='device-field' className='form-label'>
				{label}
			</label>

			<Select
				value={selectedVisibility}
				options={listItemsSelect}
				onChange={e => {
					handleSelectVisibility(e);
				}}
				name={name}
				id={name}
				classNamePrefix='select2-selection form-select'
				className={`${selectClassName}`}
				placeholder='Seleccione una opción'
				style={selectStyle}
				isClearable={true}
				isDisabled={(isLoading ? true : isDisabled)}
				isLoading={isLoading}
				loadingMessage={() => 'Cargando...'}
			/>
			{/* {invalid && <div className="invalid-feedback">{error}</div>} */}

			{invalid && !selectedVisibility ? (
				<div className='invalid-feedback'>{error}</div>
			) : null}
		</div>
	);
};

export default GeneralSelect;